/*
 * Copyright (c) 2020.
 * Project: Source
 * LastModified: 2/14/20, 3:24 PM
 * Author: diengv < Giáp Văn Điện >
 * Email: diengv@ominext.com
 * File name: index.js
 * File path: D:/Projects/PMS/Source/Client/vuejs/src/resources/components/index.js
 */


export default (Vue) => {
    Vue.component('logo', () => import('./Logo'))
    Vue.component('Loading', () => import('./loading'))
}
